module.exports = __webpack_public_path__ + "img/flags/MY.48c1a0c.png";